module.exports = __webpack_public_path__ + "img/flag-russia.9ccc56af.png";